module.exports = __webpack_public_path__ + "img/Navidad.af0ffda4.webp";